import type { PiiBackfillStateDto } from "@babackapp/private-api-client/generated/schema";
import { type BackfillStatus, summarize } from "./pii-backfill-summary";

export const EMAIL_REF_STATUSES = {
  blocked: "Backfill à terminer",
  pending: "À migrer",
  running: "En cours",
  paused: "En pause",
  done: "Migré",
} as const;

export type EmailRefStatus = keyof typeof EMAIL_REF_STATUSES;

export type ShopEmailRefSummary = {
  status: EmailRefStatus;
  /** Share of documents walked by the migration, 0 to 100. */
  percent: number;
};

/** Where a migration run stands, read from the backfill status of its rows. */
const MIGRATION_STATUSES: Record<BackfillStatus, EmailRefStatus> = {
  never: "pending",
  running: "running",
  paused: "paused",
  partial: "paused",
  done: "done",
};

/**
 * A shop is migrated once an emailRef run finished on it. Before that, it
 * waits for the migration when its backfill is finished, and for the backfill
 * otherwise: that run stamps emailRef itself.
 */
export const summarizeEmailRef = (
  states: PiiBackfillStateDto[],
): ShopEmailRefSummary => {
  const summary = summarize(states);
  const isMigrating = states.some((state) => state.mode === "emailRef");
  if (isMigrating) {
    return {
      status: MIGRATION_STATUSES[summary.status],
      percent: summary.percent,
    };
  }
  return {
    status: summary.status === "done" ? "pending" : "blocked",
    percent: 0,
  };
};
